"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _state = require("@seedlang/state");
var _src = require("@seedlang/utils/src");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var InterjectionCardWrapper = function InterjectionCardWrapper(Component) {
  var _class, _class2, _descriptor, _descriptor2;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2(props) {
      var _this;
      _classCallCheck(this, _class2);
      _this = _callSuper(this, _class2, [props]);
      _initializerDefineProperty(_this, "filteredCardCount", _descriptor, _this);
      // also in review_deck_options_wrapper.js
      _initializerDefineProperty(_this, "newDeckIsBeingCreated", _descriptor2, _this);
      _this.lastCardHandled = false;
      _this.whenLastCard = function () {
        if (_this.lastCardHandled) {
          return;
        }
        _this.lastCardHandled = true;
        if (!_state.AppUI.user.muteInterjections) {
          _state.AppUI.soundEffectStore.play('tada');
        }
        if (_state.DeckUI.reviewDeck) {
          _this.getPastDueCount();
        }
        if (_state.DeckUI.reviewDeck && _this.hasActiveFilters) {
          _this.getFilteredCardCount();
        }
      };
      _this.getPastDueCount = function () {
        _state.DeckUI.deckStore.pastDueCount({
          ids: {
            deckId: _state.DeckUI.deck.id
          }
        }, _this.afterGetPastDueCount);
      };
      _this.afterGetPastDueCount = function (resp) {
        if (_state.DeckUI.deck && _state.DeckUI.deck.setPastDueCount) {
          _state.DeckUI.deck.setPastDueCount(resp.pastDueCount);
        }
      };
      // also in review_deck_options_wrapper.js
      _this.getFilteredCardCount = function () {
        var deck = _state.DeckUI.deck;
        var filters = {
          card_type_id: deck.reviewsFilterCardTypeId,
          retired: deck.reviewsFilterRetired,
          difficulty_label: deck.reviewsFilterDifficultyLabel,
          created_at_before_after: deck.reviewsFilterCreatedAtBeforeAfter,
          created_at_days_ago: deck.reviewsFilterCreatedAtDaysAgo,
          due: deck.reviewsFilterDue
        };
        _state.AppUI.deckStore.cardsCount({
          ids: {
            deckId: deck.id
          },
          data: {
            filters: filters
          }
        }, _this.afterGetFilteredCardCount);
      };
      _this.afterGetFilteredCardCount = function (resp) {
        _this.filteredCardCount = resp.count;
      };
      _this.onCreateNewDeck = function () {
        _this.newDeckIsBeingCreated = true;
        _state.AppUI.deckStore.create({
          data: {
            sourceDeckId: _state.DeckUI.deck.id
          }
        }, _this.afterCreateNewDeck);
      };
      _this.afterCreateNewDeck = function (resp) {
        _this.newDeckIsBeingCreated = false;
        if (resp.cardsNotFound) {
          _this.routeToVocabHome();
          return;
        }
        _state.DeckUI.onCloseDeck();
        _state.DeckUI.loadDeck({
          id: resp.id
        });
      };
      _this.routeToVocabHome = function () {
        _state.AppUI.closeDeck(_state.DeckUI.treeNodeId);
        if (_state.AppUI.layout.isNative) {
          if (_this.props.navigation && _this.props.navigation.navigate) {
            _this.props.navigation.navigate('Main', {
              screen: 'Vocab',
              params: {
                screen: 'VocabHome'
              }
            });
          }
        } else {
          _state.AppUI.routeStore.routeToNamed('vocab.home', {
            page: 1
          });
        }
      };
      _state.DeckUI.enrichSentence(_this.props.card);
      if (props.card.isLastCard && props.inView) {
        _this.whenLastCard();
      }
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        if (this.props.card.isLastCard && !prevProps.inView && this.props.inView) {
          this.whenLastCard();
        }
      }
    }, {
      key: "showWordCard",
      get: function get() {
        return this.props.inView && this.props.card && this.props.card.sentence && this.props.card.sentence.state.selectedWordAssociationId;
      }
    }, {
      key: "hasActiveFilters",
      get: function get() {
        var deck = _state.DeckUI.deck;
        return (0, _src.isPresent)(deck.reviewsFilterCardTypeId) || deck.reviewsFilterRetired !== null || (0, _src.isPresent)(deck.reviewsFilterDifficultyLabel) || (0, _src.isPresent)(deck.reviewsFilterCreatedAtDaysAgo) || (0, _src.isPresent)(deck.reviewsFilterDue);
      }
    }, {
      key: "showMoreReviewsButton",
      get: function get() {
        if (!_state.DeckUI.reviewDeck) return false;

        // Check if filters would result in zero cards
        if (this.hasActiveFilters && this.filteredCardCount === 0) {
          return false;
        }
        return _state.DeckUI.deck.pastDueCount !== 0;
      }
    }, {
      key: "showNewDeckButton",
      get: function get() {
        return _state.AppUI.user.isMember && this.props.card.isLastCard && (_state.DeckUI.vocabDeck || _state.DeckUI.deck.genderDeck || _state.DeckUI.deck.synonymDeck || _state.DeckUI.deck.pluralDeck || _state.DeckUI.deck.conjugationDeck || _state.DeckUI.deck.numberDeck || _state.DeckUI.deck.caseDeck);
      }
    }, {
      key: "muteInterjection",
      get: function get() {
        return _state.AppUI.user.muteInterjections && this.props.card.isLastCard;
      }
    }, {
      key: "speechBubbleText",
      get: function get() {
        if (this.props.cardState.showType === 'source') {
          return this.props.card.sentence.sourceTextForUser(_state.DeckUI.user) || this.props.card.sentence.sourceText || this.props.card.frontText;
        }
        return this.props.card.sentence.targetText;
      }
    }, {
      key: "checkpointAchievementText",
      get: function get() {
        var _DeckUI$userDeck;
        var count = ((_DeckUI$userDeck = _state.DeckUI.userDeck) === null || _DeckUI$userDeck === void 0 ? void 0 : _DeckUI$userDeck.completedLearningUserCardsCount) || 0;
        var cardLabel = count === 1 ? 'Card' : 'Cards';
        var deckLabel = this.checkpointDeckLabel;
        return "".concat(count, " ").concat(deckLabel ? "".concat(deckLabel, " ") : '').concat(cardLabel, " Completed");
      }
    }, {
      key: "checkpointDeckLabel",
      get: function get() {
        var deck = _state.DeckUI.deck;
        if (_state.DeckUI.reviewDeck) {
          return 'Review';
        }
        if (_state.DeckUI.storyDeck) {
          return 'Story';
        }
        if (_state.DeckUI.vocabDeck) {
          return 'Vocabulary';
        }
        if (deck !== null && deck !== void 0 && deck.conjugationDeck) {
          return 'Conjugation';
        }
        if (deck !== null && deck !== void 0 && deck.genderDeck) {
          return 'Gender';
        }
        if (deck !== null && deck !== void 0 && deck.pluralDeck) {
          return 'Plural';
        }
        if (deck !== null && deck !== void 0 && deck.numberDeck) {
          return 'Number';
        }
        if (deck !== null && deck !== void 0 && deck.caseDeck) {
          return 'Case';
        }
        if (deck !== null && deck !== void 0 && deck.triviaDeck) {
          return 'Trivia';
        }
        if (deck !== null && deck !== void 0 && deck.pronunciationDeck) {
          return 'Pronunciation';
        }
        return null;
      }
    }, {
      key: "moreReviewsButtonCount",
      get: function get() {
        var deck = _state.DeckUI.deck;
        var remainingCount = deck.useDailyGoal && (0, _src.isPresent)(deck.dailyGoal) ? deck.remainingDailyGoalWithSessionProgress(_state.DeckUI.reviewSessionReviewedBaseline, _state.DeckUI.userDeck && _state.DeckUI.userDeck.progressCurrent) : deck.pastDueCount;
        if (this.hasActiveFilters) {
          return Math.min(remainingCount, this.filteredCardCount);
        }
        return remainingCount;
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          showWordCard: this.showWordCard,
          showMoreReviewsButton: this.showMoreReviewsButton,
          moreReviewsButtonCount: this.moreReviewsButtonCount,
          showNewDeckButton: this.showNewDeckButton,
          newDeckIsBeingCreated: this.newDeckIsBeingCreated,
          onCreateNewDeck: this.onCreateNewDeck,
          muteInterjection: this.muteInterjection,
          speechBubbleText: this.speechBubbleText,
          checkpointAchievementText: this.checkpointAchievementText
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "filteredCardCount", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return null;
    }
  }), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "newDeckIsBeingCreated", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _applyDecoratedDescriptor(_class2.prototype, "showWordCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showWordCard"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "hasActiveFilters", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "hasActiveFilters"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showMoreReviewsButton", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showMoreReviewsButton"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showNewDeckButton", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showNewDeckButton"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "muteInterjection", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "muteInterjection"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "speechBubbleText", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "speechBubbleText"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "checkpointAchievementText", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "checkpointAchievementText"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "checkpointDeckLabel", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "checkpointDeckLabel"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "moreReviewsButtonCount", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "moreReviewsButtonCount"), _class2.prototype), _class2)) || _class;
};
InterjectionCardWrapper.displayName = 'InterjectionCardWrapper';
var _default = exports["default"] = InterjectionCardWrapper;